'use strict';
define([
    'angular',
    'modules/settings/subscriptions/subscriptions.controller'
],function(angular,SubscriptionsCtrl){
    var app=angular.module('settings.subscriptions', []);
    app.controller('SubscriptionsCtrl',SubscriptionsCtrl);
    return app;
});